import { BranchesRetriever, LeaguesRetriever } from "./Retriever";
import { LibConfig } from "./init";
export { init } from "./init";
const branchesRetriever = new BranchesRetriever();
const leaguesRetriever = new LeaguesRetriever();
export const loadLeagues = leaguesRetriever.load.bind(leaguesRetriever);
export const loadBranches = branchesRetriever.load.bind(branchesRetriever);
export const setRegionIds = function (regionIds) {
    LibConfig.regionIds = regionIds;
};
export let mocks = {};
if (process.env.NODE_ENV === "development") {
    mocks = require("./Mocks");
}
//# sourceMappingURL=index.js.map